import { useEffect } from 'react';
import { ITrackView, trackView } from '@vfit/shared/data-access';

const BlackBoxTagging = (trackObj?: ITrackView) => {
  const trackCartOfferProposal = () => {
    if (trackObj) trackView(trackObj);
  };

  useEffect(() => {
    trackCartOfferProposal();
  }, []);

  return null;
};

export default BlackBoxTagging;
